// extracted by mini-css-extract-plugin
module.exports = {"book":"book_book__2PIku","image":"book_image__3RDHx","text":"book_text__22X29","myStyle":"book_myStyle__1WPhm","linkStyle":"book_linkStyle__3OjEl"};